import { render, staticRenderFns } from "./SendOTP.vue?vue&type=template&id=19f81c6c"
import script from "./SendOTP.vue?vue&type=script&lang=js"
export * from "./SendOTP.vue?vue&type=script&lang=js"
import style0 from "./SendOTP.vue?vue&type=style&index=0&id=19f81c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports